import { ContextualEntityChip } from "src/unifiedCopilot/chat/ContextualEntityChip";
import { parseCopilotResourceRef } from "src/unifiedCopilot/chat/contentBlocks";
import { useResourceMentionClick } from "src/unifiedCopilot/chat/useResourceMentionClick";
import { isReferenceContextualEntityType } from "src/unifiedCopilot/context/entityDefinitions";

type Props = {
  label: string;
  attrs: Record<string, string>;
  /** Composer surfaces render mentions inertly; transcripts deep-link. */
  navigable?: boolean;
};

export const ContextualEntityChatMention: React.FC<Props> = ({
  label,
  attrs,
  navigable = true,
}) => {
  const onClick = useResourceMentionClick(
    navigable ? parseCopilotResourceRef(attrs.resourceRef) : null,
  );
  const dataLoc = attrs.id ? `reference-${attrs.id}` : undefined;
  if (!isReferenceContextualEntityType(attrs.kind)) {
    return <span>{label}</span>;
  }

  return (
    <ContextualEntityChip
      dataLoc={dataLoc}
      entity={{ displayName: label, type: attrs.kind }}
      maxWidth
      onClick={onClick}
    />
  );
};
